import { render } from "./ServicesComp.vue?vue&type=template&id=f2b8d438&scoped=true"
const script = {}

import "./ServicesComp.vue?vue&type=style&index=0&id=f2b8d438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b8d438"]])

export default __exports__